import React, { Component } from 'react';
import './index.scss';
import '~/../video-react/dist/video-react.css'
import {
  Player,
  ControlBar,
  BigPlayButton,
  VolumeMenuButton
} from 'video-react'
interface configProp {
  videoSrc: string
  muted?: boolean
}
interface videoProp {
  config: configProp;
  id: string;
  pid?: string;
  clickTo: Function
}

class VideoBox extends Component<videoProp> {
  private refVideo = React.createRef()
  render() {
    const { config, id, pid, clickTo } = this.props
    const { videoSrc, muted } = config
    return (
      <div
        className="videoContent"
        data-id={id}
        data-pid={pid}
        onClick={() => clickTo('video', '', '', id)}
      >
        {videoSrc && (
          <Player
            // playsInline={true}
            ref={this.refVideo}
            poster={`${videoSrc}?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast`}
            muted={!!muted}
          >
            <source src={videoSrc} />
            <ControlBar>
              <VolumeMenuButton disabled />
            </ControlBar>
            <BigPlayButton position="center" />
          </Player>
        )}
      </div>
    )
  }
}
export default VideoBox